__turbopack_context__.v({
  "eds-card": "Card-module-scss-module__ZTh0zW__eds-card",
  "eds-card--focused": "Card-module-scss-module__ZTh0zW__eds-card--focused",
  "eds-card--neutral": "Card-module-scss-module__ZTh0zW__eds-card--neutral",
  "eds-card--raised": "Card-module-scss-module__ZTh0zW__eds-card--raised",
  "eds-card--selected": "Card-module-scss-module__ZTh0zW__eds-card--selected",
  "eds-card--simple": "Card-module-scss-module__ZTh0zW__eds-card--simple",
});
